import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M28.25 2.867H14V.053c.662-.03 1.332-.047 2-.053 3.75.033 7.567.432 9.69 1.263a8.1 8.1 0 0 1 2.56 1.604m2.157 2.96c.57 1.173.76 2.082.76 2.082q.094.39.176.784H14V5.827zm1.396 5.826c.104.974.162 1.935.185 2.867H14v-2.867zM.013 17.48h31.972c-.026.928-.09 1.889-.2 2.867H.202a35 35 0 0 1-.19-2.867m.663 5.827h30.64q-.085.409-.183.817s-.186.892-.744 2.05H1.61c-.557-1.158-.744-2.05-.744-2.05a26 26 0 0 1-.19-.817m3.071 5.826h24.505a8.1 8.1 0 0 1-2.595 1.637C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23a8.1 8.1 0 0 1-2.595-1.637",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M14 .053V14.52H.015c.06-2.108.314-4.387.851-6.645 0 0 1.03-4.918 5.476-6.646C8.061.574 10.945.188 14 .053",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m7 9.667-2.94 2.045 1.037-3.427-2.853-2.163 3.58-.073L7 2.667l1.175 3.382 3.58.073-2.853 2.163 1.037 3.427z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagLbr = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagLbr_default = SvgFlagLbr;

export { FlagLbr_default as default };
